<div *ngIf="gridData">
  <div *ngIf="ratioId && orientation === 'list'">
    <div
      style="
        background-color: #f2f4f7;
        height: 26px;
        color: black;
        font-weight: bold;
        border-top: 1px solid rgb(197, 204, 214);
        border-right: 1px solid rgb(197, 204, 214);
        border-left: 1px solid rgb(197, 204, 214);
        padding: 5px;
        font-size: 12px;
      "
    >
      {{ gridData.ratioData[ratioId]["label"] }}
    </div>
  </div>
  <div class="valuation-grid-container" [ngClass]="containerClassName">
    <table
      mat-table
      [dataSource]="dataSource"
      *ngIf="dataSource"
      cellpadding="0"
      cellspacing="0"
    >
      <!-- Ticker Column -->
      <ng-container matColumnDef="ticker" sticky>
        <th mat-header-cell *matHeaderCellDef>
          <div class="ticker-column">Ticker ({{ dataSource.length }})</div>
        </th>
        <td
          class="ticker-cell"
          [ngClass]="{ 'ticker-cell-deletion': !element.tickerDeleteDisabled }"
          mat-cell
          *matCellDef="let element"
        >
          <div class="display-flex flex-justify-between">
            <span style="padding-right: 4px; padding-left: 8px">
              <a
                class="no-decor"
                routerLink="{{ '/company/' + element.ticker }}"
                routerLinkActive
              >
                {{ element.ticker }}
              </a>
            </span>
            <span
              *ngIf="!element.tickerDeleteDisabled"
              class="del"
              (click)="deleteTicker(element)"
            >
              <va-icon
                size="small"
                name="close"
                class="table-cell-cross-icon"
              ></va-icon>
            </span>
          </div>
        </td>
        <td mat-footer-cell *matFooterCellDef class="summary-title-cell">
          <div>
            <div
              *ngIf="showAverage"
              class="data-summary-cell"
              style="padding-left: 8px; padding-top: 4px"
            >
              Average
            </div>
            <div *ngIf="showMedian" style="padding: 5px; padding-left: 8px">
              Median
            </div>
          </div>
        </td>
      </ng-container>

      <!-- Company name Column -->
      <ng-container matColumnDef="companyName">
        <th
          mat-header-cell
          *matHeaderCellDef
          (click)="sortData('companyName')"
          [ngClass]="[
            isDataInProgress ? 'disable-header-sort' : 'enable-header-sort'
          ]"
        >
          <div class="company-name-column">
            <span> Company Name </span>
            <span *ngIf="!isDataInProgress" class="sort-section">
              <div>
                <va-icon
                  isFontAwesome="true"
                  [name]="faSortUp"
                  [ngStyle]="{
                    color:
                      activeSort === 'companyName' && sortDirection === 'asc'
                        ? '#36abad'
                        : 'lightgray'
                  }"
                >
                </va-icon>
              </div>
              <div style="position: absolute; top: 10px">
                <va-icon
                  size="small"
                  name="caret-down"
                  [ngStyle]="{
                    color:
                      activeSort === 'companyName' && sortDirection === 'desc'
                        ? '#36abad'
                        : 'lightgray'
                  }"
                >
                </va-icon>
              </div>
            </span>
          </div>
        </th>
        <td mat-cell *matCellDef="let element" [title]="element.companyName">
          <div class="company-name-column" style="padding-left: 5px">
            {{ element.companyName }}
          </div>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <!-- Last Price, EOD Column -->
      <ng-container matColumnDef="lastPrice">
        <th
          mat-header-cell
          *matHeaderCellDef
          (click)="sortData('lastPrice')"
          [ngClass]="[
            isDataInProgress ? 'disable-header-sort' : 'enable-header-sort'
          ]"
        >
          <div class="last-price-column">
            <span style="display: inline-block; width: 58px">
              Last Price, EOD
            </span>
            <span *ngIf="!isDataInProgress" class="sort-section">
              <div>
                <va-icon
                  isFontAwesome="true"
                  [name]="faSortUp"
                  [ngStyle]="{
                    color:
                      activeSort === 'lastPrice' && sortDirection === 'asc'
                        ? '#36abad'
                        : 'lightgray'
                  }"
                >
                </va-icon>
              </div>
              <div style="position: absolute; top: 10px">
                <va-icon
                  size="small"
                  name="caret-down"
                  [ngStyle]="{
                    color:
                      activeSort === 'lastPrice' && sortDirection === 'desc'
                        ? '#36abad'
                        : 'lightgray'
                  }"
                >
                </va-icon>
              </div>
            </span>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          <div
            *ngIf="!element.lastPrice.formatted"
            class="ratio-cell table-cell-width"
            style="padding-left: 5px; padding-right: 5px"
          >
            <nz-skeleton
              [nzTitle]="true"
              [nzActive]="true"
              [nzParagraph]="false"
            ></nz-skeleton>
          </div>
          <div
            *ngIf="element.lastPrice.formatted"
            class="ratio-cell table-cell-width"
            [ngClass]="{
              'negative-value': element.lastPrice.raw < 0,
              'selected-cell': selectedCell === element.ticker + '_lastPrice_'
            }"
            (click)="
              onCellClick(
                $event,
                element['lastPrice']['rd'],
                'lastPrice',
                undefined,
                element.ticker,
                element.ticker,
                element['lastPrice']['currency'],
                element['lastPrice']['isForecast']
              )
            "
          >
            <ng-container
              *ngIf="element.lastPrice.formatted !== '-'; else emptyData"
            >
              <span nz-tooltip [nzTooltipTitle]="lastPriceTooltip">
                {{ element.lastPrice.formatted }}
              </span>
            </ng-container>
            <ng-template #emptyData>
              <span>
                {{ element.lastPrice.formatted }}
              </span>
            </ng-template>
          </div>
          <ng-template #lastPriceTooltip>
            <div class="ca-tooltip-content">
              {{ element.lastPrice.formatted }}
              <br />
              {{ element.lastPrice.lastDate }}
              <br />
              {{ element.lastPrice.exchangeFullName }}
            </div>
          </ng-template>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <!-- Market cap Column -->
      <ng-container matColumnDef="marketCap">
        <th
          mat-header-cell
          *matHeaderCellDef
          (click)="sortData('marketCap')"
          [ngClass]="[
            isDataInProgress ? 'disable-header-sort' : 'enable-header-sort'
          ]"
        >
          <div class="market-cap-column">
            <span style="display: inline-block; width: 58px"> Market cap </span>
            <span
              [ngClass]="{ 'hide-sort-button': isDataInProgress }"
              class="sort-section"
            >
              <div>
                <va-icon
                  isFontAwesome="true"
                  [name]="faSortUp"
                  [ngStyle]="{
                    color:
                      activeSort === 'marketCap' && sortDirection === 'asc'
                        ? '#36abad'
                        : 'lightgray'
                  }"
                >
                </va-icon>
              </div>
              <div style="position: absolute; top: 10px">
                <va-icon
                  size="small"
                  name="caret-down"
                  [ngStyle]="{
                    color:
                      activeSort === 'marketCap' && sortDirection === 'desc'
                        ? '#36abad'
                        : 'lightgray'
                  }"
                >
                </va-icon>
              </div>
            </span>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          <div
            *ngIf="!element.marketCap.formatted"
            class="ratio-cell table-cell-width"
            style="padding-left: 5px; padding-right: 5px"
          >
            <nz-skeleton
              [nzTitle]="true"
              [nzActive]="true"
              [nzParagraph]="false"
            ></nz-skeleton>
          </div>
          <div
            *ngIf="element.marketCap.formatted"
            class="ratio-cell table-cell-width"
            [ngClass]="{
              'negative-value': element.marketCap.raw < 0,
              'selected-cell': selectedCell === element.ticker + '_marketCap_'
            }"
            (click)="
              onCellClick(
                $event,
                element['marketCap']['rd'],
                'marketCap',
                undefined,
                element.ticker,
                element.ticker,
                element['marketCap']['currency'],
                element['marketCap']['isForecast']
              )
            "
          >
            <ng-container
              *ngIf="element.marketCap.formatted !== '-'; else emptyData"
            >
              <span nz-tooltip [nzTooltipTitle]="mkapTooltip">
                {{ element.marketCap.formatted }}
              </span>
            </ng-container>
            <ng-template #emptyData>
              <span>
                {{ element.marketCap.formatted }}
              </span>
            </ng-template>
          </div>
          <ng-template #mkapTooltip>
            <div class="ca-tooltip-content">
              {{ element.marketCap.formatted }}
              <br />
              {{ element.marketCap.lastDate }}
              <br />
              {{ element.marketCap.exchangeFullName }}
            </div>
          </ng-template>
        </td>
        <td mat-footer-cell *matFooterCellDef>
          <div class="data-summary-cell" *ngIf="showAverage">
            <ng-container>
              <div
                *ngIf="!gridData.footerData.average.marketCap"
                class="ratio-cell table-cell-width"
                style="
                  padding-left: 5px;
                  padding-right: 5px;
                  display: inline-block;
                "
              >
                <nz-skeleton
                  [nzTitle]="true"
                  [nzActive]="true"
                  [nzParagraph]="false"
                ></nz-skeleton>
              </div>
              <div
                *ngIf="gridData.footerData.average.marketCap"
                class="ratio-cell table-cell-width"
                style="display: inline-block"
                [ngClass]="{
                  'negative-value':
                    gridData.footerData.average.marketCap['raw'] < 0
                }"
                [title]="gridData.footerData.average.marketCap.formatted"
              >
                {{ gridData.footerData.average.marketCap["formatted"] }}
              </div>
            </ng-container>
          </div>
          <div class="data-summary-cell" *ngIf="showMedian">
            <ng-container>
              <div
                *ngIf="!gridData.footerData.median.marketCap"
                class="ratio-cell table-cell-width"
                style="
                  padding-left: 5px;
                  padding-right: 5px;
                  display: inline-block;
                "
              >
                <nz-skeleton
                  [nzTitle]="true"
                  [nzActive]="true"
                  [nzParagraph]="false"
                ></nz-skeleton>
              </div>
              <div
                *ngIf="gridData.footerData.median.marketCap"
                class="ratio-cell table-cell-width"
                style="display: inline-block"
                [ngClass]="{
                  'negative-value':
                    gridData.footerData.median.marketCap['raw'] < 0
                }"
                [title]="gridData.footerData.median.marketCap.formatted"
              >
                {{ gridData.footerData.median.marketCap["formatted"] }}
              </div>
            </ng-container>
          </div>
        </td>
      </ng-container>

      <!-- EV Column -->
      <ng-container matColumnDef="ev">
        <th
          mat-header-cell
          *matHeaderCellDef
          (click)="sortData('ev')"
          [ngClass]="[
            isDataInProgress ? 'disable-header-sort' : 'enable-header-sort'
          ]"
        >
          <div class="ev-column">
            <span style="display: inline-block; width: 58px">
              Enterprise Value
            </span>
            <span
              [ngClass]="{ 'hide-sort-button': isDataInProgress }"
              class="sort-section"
            >
              <div>
                <va-icon
                  isFontAwesome="true"
                  [name]="faSortUp"
                  [ngStyle]="{
                    color:
                      activeSort === 'ev' && sortDirection === 'asc'
                        ? '#36abad'
                        : 'lightgray'
                  }"
                >
                </va-icon>
              </div>
              <div style="position: absolute; top: 10px">
                <va-icon
                  size="small"
                  name="caret-down"
                  [ngStyle]="{
                    color:
                      activeSort === 'ev' && sortDirection === 'desc'
                        ? '#36abad'
                        : 'lightgray'
                  }"
                >
                </va-icon>
              </div>
            </span>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          <div
            *ngIf="!element.ev.formatted"
            class="ratio-cell table-cell-width"
            style="padding-left: 5px; padding-right: 5px"
          >
            <nz-skeleton
              [nzTitle]="true"
              [nzActive]="true"
              [nzParagraph]="false"
            ></nz-skeleton>
          </div>
          <div
            *ngIf="element.ev.formatted"
            class="ratio-cell table-cell-width"
            [ngClass]="{
              'negative-value': element.ev.raw < 0,
              'selected-cell': selectedCell === element.ticker + '_ev_'
            }"
            (click)="
              onCellClick(
                $event,
                element['ev']['rd'],
                'ev',
                undefined,
                element.ticker,
                element.ticker,
                element['ev']['currency'],
                element['ev']['isForecast']
              )
            "
          >
            <ng-container *ngIf="element.ev.formatted !== '-'; else emptyData">
              <span nz-tooltip [nzTooltipTitle]="evTooltip">
                {{ element.ev.formatted }}
              </span>
            </ng-container>
            <ng-template #emptyData>
              <span>
                {{ element.ev.formatted }}
              </span>
            </ng-template>
          </div>
          <ng-template #evTooltip>
            <div class="ca-tooltip-content">
              {{ element.ev.formatted }}
              <br />
              {{ element.ev.lastDate }}
              <br />
              {{ element.ev.exchangeFullName }}
            </div>
          </ng-template>
        </td>
        <td mat-footer-cell *matFooterCellDef>
          <div class="data-summary-cell" *ngIf="showAverage">
            <ng-container>
              <div
                *ngIf="!gridData.footerData.average.ev"
                class="ratio-cell table-cell-width"
                style="
                  padding-left: 5px;
                  padding-right: 5px;
                  display: inline-block;
                "
              >
                <nz-skeleton
                  [nzTitle]="true"
                  [nzActive]="true"
                  [nzParagraph]="false"
                ></nz-skeleton>
              </div>
              <div
                *ngIf="gridData.footerData.average.ev"
                class="ratio-cell table-cell-width"
                style="display: inline-block"
                [ngClass]="{
                  'negative-value': gridData.footerData.average.ev['raw'] < 0
                }"
                [title]="gridData.footerData.average.ev.formatted"
              >
                {{ gridData.footerData.average.ev["formatted"] }}
              </div>
            </ng-container>
          </div>
          <div class="data-summary-cell" *ngIf="showMedian">
            <ng-container>
              <div
                *ngIf="!gridData.footerData.median.ev"
                class="ratio-cell table-cell-width"
                style="
                  padding-left: 5px;
                  padding-right: 5px;
                  display: inline-block;
                "
              >
                <nz-skeleton
                  [nzTitle]="true"
                  [nzActive]="true"
                  [nzParagraph]="false"
                ></nz-skeleton>
              </div>
              <div
                *ngIf="gridData.footerData.median.ev"
                class="ratio-cell table-cell-width"
                style="display: inline-block"
                [ngClass]="{
                  'negative-value': gridData.footerData.median.ev['raw'] < 0
                }"
                [title]="gridData.footerData.median.ev.formatted"
              >
                {{ gridData.footerData.median.ev["formatted"] }}
              </div>
            </ng-container>
          </div>
        </td>
      </ng-container>

      <!-- Metrics Column -->
      <ng-container matColumnDef="metrics" sticky>
        <th
          mat-header-cell
          *matHeaderCellDef
          title="Metrics"
          style="font-size: 14px"
        >
          Metrics
        </th>
        <td
          mat-cell
          *matCellDef="let element"
          style="
            font-size: 12px;
            border-bottom: 1px solid #afafaf;
            max-width: 370px;
          "
        >
          <!-- <div
          *ngFor="let ratio of ratioOnly"
        >
        <div>{{element.ratio && element.ratio.denom}}</div>
      </div> -->
          <div
            class="metrics"
            style="font-weight: 600"
            [ngClass]="{ 'row-border': element.denom }"
            [title]="gridData.ratioData[element.ratio].label"
          >
            {{ gridData.ratioData[element.ratio].label }}
          </div>
          <div
            class="metrics"
            [ngClass]="{ 'row-border': element.denom_yoy }"
            *ngIf="element.denom"
            [title]="gridData.ratioData[element.denom].label"
          >
            {{ element.denom && gridData.ratioData[element.denom].label }}
          </div>
          <div
            class="metrics"
            *ngIf="element.denom_yoy"
            style="font-style: italic"
            [title]="gridData.ratioData[element.denom_yoy].label"
          >
            {{
              element.denom_yoy && gridData.ratioData[element.denom_yoy].label
            }}
          </div>
        </td>
      </ng-container>

      <ng-container *ngIf="orientation === 'grid'">
        <ng-container *ngFor="let col of ratios">
          <ng-container [matColumnDef]="col">
            <th
              style="padding: 5px 0px 5px 0px"
              mat-header-cell
              *matHeaderCellDef
            >
              <div
                class="ratio-column-header"
                [title]="gridData.ratioData[col]['label']"
                [ngStyle]="{ 'width.px': periodWidth }"
              >
                {{ gridData.ratioData[col]["label"] }}
              </div>
              <div class="ratio-column-subheader">
                <div
                  *ngFor="let period of gridData.periods"
                  class="ratio-period table-cell-sub-column-cell"
                  (click)="sortData(col + '|' + period)"
                  [ngClass]="[
                    isDataInProgress
                      ? 'disable-header-sort'
                      : 'enable-header-sort'
                  ]"
                >
                  <span>{{ period }}</span>
                  <span
                    [ngClass]="{ 'hide-sort-button': isDataInProgress }"
                    class="sort-section"
                  >
                    <div>
                      <va-icon
                        isFontAwesome="true"
                        [name]="faSortUp"
                        [ngStyle]="{
                          color:
                            activeSort === col + '|' + period &&
                            sortDirection === 'asc'
                              ? '#36abad'
                              : 'lightgray'
                        }"
                      >
                      </va-icon>
                    </div>
                    <div style="position: absolute; top: 40px">
                      <va-icon
                        size="small"
                        name="caret-down"
                        [ngStyle]="{
                          color:
                            activeSort === col + '|' + period &&
                            sortDirection === 'desc'
                              ? '#36abad'
                              : 'lightgray'
                        }"
                      >
                      </va-icon>
                    </div>
                  </span>
                </div>
              </div>
            </th>
            <td mat-cell *matCellDef="let element">
              <div class="display-flex">
                <ng-container *ngFor="let period of gridData.periods">
                  <div
                    *ngIf="!element[col][period]['formatted']"
                    class="ratio-cell"
                    style="
                      padding-left: 5px;
                      padding-right: 5px;
                      display: inline-block;
                    "
                  >
                    <nz-skeleton
                      [nzTitle]="true"
                      [nzActive]="true"
                      [nzParagraph]="false"
                    ></nz-skeleton>
                  </div>
                  <div
                    *ngIf="element[col][period]['formatted']"
                    class="table-cell-sub-column-cell"
                  >
                    <div style="display: flex; height: 26px">
                      <div
                        class="ratio-cell"
                        style="display: inline-block"
                        [ngClass]="{
                          'negative-value': element[col][period]['raw'] < 0,
                          'selected-cell':
                            selectedCell ===
                            element.ticker + '_' + col + '_' + period,
                          'gaap-cell':
                            element[col][period]['primarySli'] === 'GAAP' &&
                            highlightGAAP
                        }"
                        [title]="element[col][period].formatted"
                        (click)="
                          onCellClick(
                            $event,
                            element[col][period]['rd'],
                            col,
                            period,
                            element.ticker,
                            element.ticker,
                            element[col][period]['currency'],
                            element[col][period]['isForecast']
                          )
                        "
                      >
                        {{ element[col][period]["formatted"] }}
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </td>
            <td mat-footer-cell *matFooterCellDef="let footer">
              <div class="data-summary-cell display-flex" *ngIf="showAverage">
                <ng-container *ngFor="let period of gridData.periods">
                  <div
                    *ngIf="!gridData.footerData.average[col]"
                    class="ratio-cell table-cell-sub-column-cell"
                    style="
                      padding-left: 5px;
                      padding-right: 5px;
                      display: inline-block;
                    "
                  >
                    <nz-skeleton
                      [nzTitle]="true"
                      [nzActive]="true"
                      [nzParagraph]="false"
                    ></nz-skeleton>
                  </div>
                  <div
                    *ngIf="gridData.footerData.average[col]"
                    class="ratio-cell table-cell-sub-column-cell"
                    style="display: inline-block"
                    [ngClass]="{
                      'negative-value':
                        gridData.footerData.average[col][period]['raw'] < 0
                    }"
                    [title]="gridData.footerData.average[col][period].formatted"
                  >
                    {{ gridData.footerData.average[col][period]["formatted"] }}
                  </div>
                </ng-container>
              </div>
              <div class="data-summary-cell display-flex" *ngIf="showMedian">
                <ng-container *ngFor="let period of gridData.periods">
                  <div
                    *ngIf="!gridData.footerData.median[col]"
                    class="ratio-cell table-cell-sub-column-cell"
                    style="
                      padding-left: 5px;
                      padding-right: 5px;
                      display: inline-block;
                    "
                  >
                    <nz-skeleton
                      [nzTitle]="true"
                      [nzActive]="true"
                      [nzParagraph]="false"
                    ></nz-skeleton>
                  </div>
                  <div
                    *ngIf="gridData.footerData.median[col]"
                    class="ratio-cell table-cell-sub-column-cell"
                    style="display: inline-block"
                    [ngClass]="{
                      'negative-value':
                        gridData.footerData.median[col][period]['raw'] < 0
                    }"
                    [title]="gridData.footerData.median[col][period].formatted"
                  >
                    {{ gridData.footerData.median[col][period]["formatted"] }}
                  </div>
                </ng-container>
              </div>
            </td>
          </ng-container>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="orientation === 'list'">
        <ng-container *ngFor="let period of gridData.periods">
          <ng-container [matColumnDef]="period">
            <th
              [ngStyle]="{ 'width.px': periodWidth }"
              style="text-align: center"
              (click)="sortData(ratioId + '|' + period)"
              [ngClass]="[
                isDataInProgress ? 'disable-header-sort' : 'enable-header-sort'
              ]"
              mat-header-cell
              *matHeaderCellDef
            >
              <span>
                {{ period }}
              </span>
              <span
                [ngClass]="{ 'hide-sort-button': isDataInProgress }"
                class="sort-section"
              >
                <div>
                  <va-icon
                    isFontAwesome="true"
                    [name]="faSortUp"
                    [ngStyle]="{
                      color:
                        activeSort === ratioId + '|' + period &&
                        sortDirection === 'asc'
                          ? '#36abad'
                          : 'lightgray'
                    }"
                  >
                  </va-icon>
                </div>
                <div style="position: absolute; top: 10px">
                  <va-icon
                    size="small"
                    name="caret-down"
                    [ngStyle]="{
                      color:
                        activeSort === ratioId + '|' + period &&
                        sortDirection === 'desc'
                          ? '#36abad'
                          : 'lightgray'
                    }"
                  >
                  </va-icon>
                </div>
              </span>
            </th>
            <td
              [ngStyle]="{ 'maxWidth.px': periodWidth }"
              style="text-align: right"
              mat-cell
              *matCellDef="let element"
            >
              <div
                *ngIf="
                  element[ratioId] && !element[ratioId][period]['formatted']
                "
                class="ratio-cell"
                style="
                  padding-left: 5px;
                  padding-right: 5px;
                  display: inline-block;
                "
              >
                <nz-skeleton
                  [nzTitle]="true"
                  [nzActive]="true"
                  [nzParagraph]="false"
                ></nz-skeleton>
              </div>
              <div
                *ngIf="
                  element[ratioId] && element[ratioId][period]['formatted']
                "
                style="display: flex; height: 26px"
              >
                <div
                  class="ratio-cell"
                  style="display: inline-block"
                  [ngClass]="{
                    'negative-value': element[ratioId][period]['raw'] < 0,
                    'selected-cell':
                      selectedCell ===
                      element.ticker + '_' + ratioId + '_' + period,
                    'gaap-cell':
                      element[ratioId][period]['primarySli'] === 'GAAP' &&
                      highlightGAAP
                  }"
                  [title]="element[ratioId][period].formatted"
                  (click)="
                    onCellClick(
                      $event,
                      element[ratioId][period]['rd'],
                      ratioId,
                      period,
                      element.ticker,
                      element.ticker,
                      element[ratioId][period]['currency'],
                      element[ratioId][period]['isForecast']
                    )
                  "
                >
                  {{ element[ratioId][period]["formatted"] }}
                </div>
              </div>
            </td>
            <td mat-footer-cell *matFooterCellDef="let footer">
              <div class="data-summary-cell" *ngIf="showAverage">
                <div
                  *ngIf="!gridData.footerData.average[ratioId]"
                  class="ratio-cell table-cell-sub-column-cell"
                  style="
                    padding-left: 5px;
                    padding-right: 5px;
                    display: inline-block;
                  "
                >
                  <nz-skeleton
                    [nzTitle]="true"
                    [nzActive]="true"
                    [nzParagraph]="false"
                  ></nz-skeleton>
                </div>
                <div
                  *ngIf="gridData.footerData.average[ratioId]"
                  class="ratio-cell table-cell-sub-column-cell"
                  style="display: inline-block"
                  [ngClass]="{
                    'negative-value':
                      gridData.footerData.average[ratioId][period]['raw'] < 0
                  }"
                  [title]="
                    gridData.footerData.average[ratioId][period].formatted
                  "
                >
                  {{
                    gridData.footerData.average[ratioId][period]["formatted"]
                  }}
                </div>
              </div>
              <div class="data-summary-cell" *ngIf="showMedian">
                <div
                  *ngIf="!gridData.footerData.median[ratioId]"
                  class="ratio-cell table-cell-sub-column-cell"
                  style="
                    padding-left: 5px;
                    padding-right: 5px;
                    display: inline-block;
                  "
                >
                  <nz-skeleton
                    [nzTitle]="true"
                    [nzActive]="true"
                    [nzParagraph]="false"
                  ></nz-skeleton>
                </div>
                <div
                  *ngIf="gridData.footerData.median[ratioId]"
                  class="ratio-cell table-cell-sub-column-cell"
                  style="display: inline-block"
                  [ngClass]="{
                    'negative-value':
                      gridData.footerData.median[ratioId][period]['raw'] < 0
                  }"
                  [title]="
                    gridData.footerData.median[ratioId][period].formatted
                  "
                >
                  {{ gridData.footerData.median[ratioId][period]["formatted"] }}
                </div>
              </div>
            </td>
          </ng-container>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="orientation === 'company'">
        <ng-container *ngFor="let period of gridData.periods">
          <ng-container [matColumnDef]="period">
            <th
              [ngStyle]="{ 'width.px': periodWidth }"
              style="text-align: center; font-size: 14px"
              (click)="companySortData(period)"
              [ngClass]="[
                isDataInProgress ? 'disable-header-sort' : 'enable-header-sort'
              ]"
              mat-header-cell
              *matHeaderCellDef
            >
              <span>
                {{ period }}
              </span>
              <span
                [ngClass]="{ 'hide-sort-button': isDataInProgress }"
                class="sort-section"
              >
                <div>
                  <va-icon
                    isFontAwesome="true"
                    [name]="faSortUp"
                    [ngStyle]="{
                      color:
                        activeSort === period && sortDirection === 'asc'
                          ? '#36abad'
                          : 'lightgray'
                    }"
                  >
                  </va-icon>
                </div>
                <div style="position: absolute; top: 10px">
                  <va-icon
                    size="small"
                    name="caret-down"
                    [ngStyle]="{
                      color:
                        activeSort === period && sortDirection === 'desc'
                          ? '#36abad'
                          : 'lightgray'
                    }"
                  >
                  </va-icon>
                </div>
              </span>
            </th>
            <td
              [ngStyle]="{ 'width.px': periodWidth }"
              style="text-align: right; border-bottom: 1px solid #afafaf"
              mat-cell
              *matCellDef="let element"
            >
              <span
                *ngIf="
                  gridData.rowData[0] &&
                  !gridData.rowData[0][element.ratio][period]['formatted']
                "
                class="metrics"
                style="padding-left: 5px; padding-right: 5px"
              >
                <nz-skeleton
                  [nzTitle]="true"
                  [nzActive]="true"
                  [nzParagraph]="false"
                ></nz-skeleton>
              </span>
              <div
                *ngIf="
                  gridData.rowData[0] &&
                  gridData.rowData[0][element.ratio][period]['formatted']
                "
                class="metrics"
                style="font-weight: 600"
                [ngClass]="{
                  'negative-value':
                    gridData.rowData[0][element.ratio][period]['raw'] < 0,
                  'row-border':
                    (element.denom_yoy &&
                      gridData.rowData[0] &&
                      gridData.rowData[0][element.denom_yoy][period][
                        'formatted'
                      ]) ||
                    (element.denom &&
                      gridData.rowData[0] &&
                      gridData.rowData[0][element.denom][period]['formatted']),
                  'selected-cell':
                    selectedCell ===
                    gridData.rowData[index].ticker +
                      '_' +
                      element.ratio +
                      '_' +
                      period,
                  'gaap-cell':
                    gridData.rowData[index][element.ratio][period][
                      'primarySli'
                    ] === 'GAAP' && highlightGAAP
                }"
                (click)="
                  onCellClick(
                    $event,
                    gridData.rowData[index][element.ratio][period]['rd'],
                    element.ratio,
                    period,
                    gridData.rowData[index].ticker,
                    element.ratio,
                    gridData.ratioData[element.ratio].currency,
                    gridData.rowData[index][element.ratio][period].isForecast
                  )
                "
                [title]="
                  gridData.rowData[index][element.ratio][period].formatted
                "
              >
                {{
                  gridData.rowData[index][element.ratio][period]["formatted"]
                }}
              </div>
              <div
                *ngIf="
                  element.denom &&
                  gridData.rowData[0] &&
                  gridData.rowData[0][element.denom][period]['formatted']
                "
                class="metrics"
                [ngClass]="{
                  'negative-value':
                    gridData.rowData[0][element.denom][period]['raw'] < 0,
                  'row-border':
                    element.denom_yoy &&
                    gridData.rowData[0] &&
                    gridData.rowData[0][element.denom_yoy][period]['formatted'],
                  'selected-cell':
                    selectedCell ===
                    gridData.rowData[index].ticker +
                      '_' +
                      element.denom +
                      '_' +
                      period,
                  'gaap-cell':
                    gridData.rowData[index][element.denom][period][
                      'primarySli'
                    ] === 'GAAP' && highlightGAAP
                }"
                (click)="
                  onCellClick(
                    $event,
                    gridData.rowData[index][element.denom][period]['rd'],
                    element.denom,
                    period,
                    gridData.rowData[index].ticker,
                    element.denom,
                    gridData.ratioData[element.denom].currency,
                    gridData.rowData[index][element.denom][period].isForecast
                  )
                "
                [title]="
                  gridData.rowData[index][element.denom][period].formatted
                "
              >
                {{
                  gridData.rowData[index][element.denom][period]["formatted"]
                }}
              </div>
              <div
                *ngIf="
                  element.denom_yoy &&
                  gridData.rowData[0] &&
                  gridData.rowData[0][element.denom_yoy][period]['formatted']
                "
                class="metrics"
                style="font-style: italic"
                [ngClass]="{
                  'negative-value':
                    gridData.rowData[0][element.denom_yoy][period]['raw'] < 0,
                  'selected-cell':
                    selectedCell ===
                    gridData.rowData[index].ticker +
                      '_' +
                      element.denom_yoy +
                      '_' +
                      period,
                  'gaap-cell':
                    gridData.rowData[index][element.denom_yoy][period][
                      'primarySli'
                    ] === 'GAAP' && highlightGAAP
                }"
                (click)="
                  onCellClick(
                    $event,
                    gridData.rowData[index][element.denom_yoy][period]['rd'],
                    element.denom_yoy,
                    period,
                    gridData.rowData[index].ticker,
                    element.denom_yoy,
                    gridData.ratioData[element.denom_yoy].currency,
                    gridData.rowData[index][element.denom_yoy][period]
                      .isForecast
                  )
                "
                [title]="
                  gridData.rowData[index][element.denom_yoy][period].formatted
                "
              >
                {{
                  gridData.rowData[index][element.denom_yoy][period][
                    "formatted"
                  ]
                }}
              </div>
            </td>
          </ng-container>
        </ng-container>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <ng-container *ngIf="tabType !== 'company'">
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          [ngClass]="{ 'selected-row': selectedRow == row.ticker }"
          (click)="onRowClick(row.ticker)"
        ></tr>
      </ng-container>
      <ng-container *ngIf="tabType === 'company'">
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          [ngClass]="{
            'selected-row':
              selectedRow == row.ratio ||
              selectedRow == row.denom ||
              selectedRow == row.denom_yoy
          }"
          (click)="onRowClick(row.ratio)"
        ></tr>
      </ng-container>
      <ng-container *ngIf="tabType !== 'company'">
        <tr
          mat-footer-row
          *matFooterRowDef="displayedColumns; sticky: true"
        ></tr>
      </ng-container>
    </table>
  </div>
</div>
<div *ngIf="!gridData">
  <div class="valuation-grid-container">
    <ul nz-menu>
      <li
        *ngFor="let dummySection of [0, 1, 2, 3, 4, 5]"
        style="padding: 0px 15px 0px 15px"
      >
        <nz-skeleton
          [nzTitle]="true"
          [nzActive]="true"
          [nzParagraph]="false"
        ></nz-skeleton>
      </li>
    </ul>
  </div>
</div>
